import { render } from "./ForRookie.vue?vue&type=template&id=b9f76e2a&scoped=true&ts=true"
import script from "./ForRookie.vue?vue&type=script&lang=ts"
export * from "./ForRookie.vue?vue&type=script&lang=ts"

import "./ForRookie.vue?vue&type=style&index=0&id=b9f76e2a&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f76e2a"]])

export default __exports__